export const list = [
    {
        label: '关于我省2023年度9月份软件企业复评和重新评估的通知',
        text: `根据中国软件行业协会《软件企业评估标准》（T/SIA002-2019）以及湖北省软件行业协会《湖北省软件企业评估实施细则》
        的有关规定，《软件企业证书》有效期为一年，企业通过首次评估后，在有效期届满前第二年和第三年只需按时参加复评，
        第四年则需按照首次评估的要求重新评估，若未按时参加复评和重新评估或未通过的企业，其《软件企业证书》将自动失效。`,
        tags: ['软件企业', '《软件企业证书》'],
        time: '2021-12-03',
        page: '',
        image: require('@/assets/image/newsMedia/groupHonor/honor_1.png')
    },
    {
        label: '我司开发的农村公路信息化成功入选交通运输部应用经验典型案例',
        text: `交通运输部管理干部学院关于举办第十三期农村公路管理暨“四好农村路”示范创建工作培训班通知中，羿畅科技所开发的潜江市农村公路管理信息化系统成功入选农村公路信息化应用经验分享典型案例，
        感谢相关领导的认可与肯定，我们将一如既往践行工匠精神，以专注之心，铸就精品，为客户朋友持续提供优质服务和良好体验。`,
        tags: ['四好农村路'],
        time: '2023-2-23',
        page: '',
        image: require('@/assets/image/newsMedia/groupHonor/honor_2.png')
    },
    {
        label: '农村公路“一路一档”信息化试点任务技术支持单位农村公路“一路一档”信息化试点任务技术支持单位',
        text: `交通运输部办公厅关于开展农村公路“一路一档”信息化建设试点申报工作中，羿畅科技所开发的农村公路信息化综合管理平台，
        于2019年交付的远安县、潜江市农村公路养护管理系统，经过实地调研和筛选，相关领导给予充分肯定，入选省级试点参与单位。`,
        tags: ['一路一档'],
        time: '2023-2-23',
        page: '',
        image: null
    },
]
